import KFocused from '../../core/mixins/focused/KFocused'
import KButton from '../button'
import { KeyCode } from '../../core/KConstants'
import $ from 'jquery'

export default {
  name: 'KSwitch',
  mixins: [KFocused],
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    checked: {
      validator: () => true,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  render() {
    const attrs = {
      attrs: {
        tabindex: 0,
      },
    }

    const switchCss = {
      class: {
        'is-disabled': this.disabled,
        'km-switch--checked': this.checked,
        [`km-switch--${this.type}`]: true,
      },
    }

    const loadingType = this.checked ? 'white' : this.type

    // this.rippleType = this.checked ? this.type : 'white'

    return (
      <label class="km-switch" {...switchCss} {...attrs} onClick={this.handleLabelClick} onKeydown={this.handleKeydown}>
        <input
          class="km-switch__input"
          ref="input"
          type="checkbox"
          disabled={this.disabled}
          checked={this.checked}
          onChange={this.handleChange}
        />

        <div class="km-switch__track">
          <div class="km-switch__thumb">
            {this.loading ? <k-loading type={loadingType} name="spinner" size="mini" /> : this.$slots.thumb}
            <KButton
              class="km-switch__ripple"
              {...{ class: { 'is-hovered': this.kHasFocus } }}
              disabled={this.disabled}
              onClick={this.handleButtonClick}
              ref="button"
              circle
              plain
              size="large"
              type={this.type}
            />
          </div>
        </div>

        <div ref="label" class="km-switch__label">
          {this.$slots.default}
        </div>
      </label>
    )
  },
  methods: {
    handleKeydown(e) {
      if (e.which === KeyCode.ENTER) {
        $(this.$el).trigger('click')
      }
    },
    handleButtonClick() {
      this.$refs.input.click()
    },
    handleLabelClick() {
      // this.$refs.button && this.$refs.button.emulateForceClick(100)
    },
    handleChange(e) {
      this.$emit('change', e.target.checked)
    },
  },
}
